/* eslint-disable multiline-ternary */
import { Loader, Modal, Typography } from 'src/components/common';
import './LikeUserModal.scss';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import { TLikeUser } from 'src/components/posts/postCard/PostCard';
import { useNavigate } from 'react-router-dom';
import { useGetIdentity } from 'src/hooks';

const LikeUserModal = ({ isModalOpen, title, handleCloseModal, users }: { isModalOpen: boolean, title: string, handleCloseModal: () => void, users: TLikeUser[] }) => {
    const navigate = useNavigate();
    const { getIdentities } = useGetIdentity();
    // Constants
  const { authenticatedId, loggedInUserType, loggedInCompanyId } = getIdentities();
    function handleRedirect(item: TLikeUser) {
        if (item?.type) {
             const path = item?.userId === loggedInCompanyId ? '/my-company' : `/view-company?id=${item?.userId || item?.id}`
            navigate(path)
        } else {
            const path = item?.userId === authenticatedId ? '/my-profile' : `/view-profile?id=${item?.userId || item?.id}`
            navigate(path)
        }
    }
    console.log('users', users)
    return (
        <Modal
            isModalOpen={isModalOpen}
            onModalClose={handleCloseModal}
            title={title}
            className="create-edit-post-modal likeReaction_modal"
        >
            <ul>
                {users?.map((item: TLikeUser, i: number) => {
                    const profilePic = item?.profilePic ? item?.profilePic : item?.logo;
                    return (
                        <li key={i} onClick={() => handleRedirect(item)}>
                            <ProfilePicture url={`${profilePic}?v=2`} fallback={item?.name?.[0]} />
                            <div className='likeReaction_content'>
                                <Typography
                                    as="h4"
                                    variant="body-1"
                                    fontWeight="semiBold"
                                >
                                    {item?.name}
                                </Typography>
                                <Typography
                                    as="p"
                                    variant="caption"
                                    fontWeight="regular"
                                >
                                    {item?.role || item?.type}
                                </Typography>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </Modal>
    );
};

export default LikeUserModal;
